import { Product } from './product.types';
import { StationeryProduct } from '@shared/utils/print-price/types';
import { useProductTypes } from './useProductTypes';

export const useProductToUIMapping = () => {
  const productTypes = useProductTypes();

  return {
    getProductWithUIMapping: (productInput: StationeryProduct): (StationeryProduct & Product) | null => {
      const productUIMapping = productTypes.find(prod => prod.type === productInput.productType);
      if (!productUIMapping || !productInput) return null;
      return {
        ...productInput,
        ...productUIMapping,
      };
    },
  };
};
